export const formatMoney = (amount, currency = "ZAR") => {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat("en-ZA", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(n);
  } catch {
    return `R ${n.toFixed(2)}`;
  }
};
